import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Trang thương hiệu cá nhân là gì?',
      answer: 'Trang thương hiệu cá nhân là website giới thiệu về bạn, dịch vụ/sản phẩm của bạn một cách chuyên nghiệp. Nó giúp bạn xây dựng hình ảnh đáng tin cậy, thu hút khách hàng và phát triển sự nghiệp.'
    },
    {
      question: 'Tôi cần chuẩn bị gì để đăng ký?',
      answer: 'Bạn chỉ cần chuẩn bị thông tin cơ bản như: tên, lĩnh vực hoạt động, dịch vụ/sản phẩm, ảnh cá nhân và một số hình ảnh minh họa. Đội ngũ của chúng tôi sẽ hỗ trợ bạn hoàn thiện phần còn lại.'
    },
    {
      question: 'Thời gian hoàn thành là bao lâu?',
      answer: 'Thông thường, chúng tôi sẽ hoàn thành trang của bạn trong vòng 3-5 ngày làm việc sau khi nhận đầy đủ thông tin và thanh toán. Trường hợp khẩn cấp, chúng tôi có thể giao nhanh hơn.'
    },
    {
      question: 'Tôi có thể tự chỉnh sửa nội dung sau này không?',
      answer: 'Có, chúng tôi sẽ hướng dẫn bạn cách cập nhật nội dung cơ bản. Nếu cần thay đổi lớn về thiết kế, đội ngũ của chúng tôi sẽ hỗ trợ bạn trong thời gian bảo hành 30 ngày.'
    },
    {
      question: 'Giá 70.000đ đã bao gồm những gì?',
      answer: 'Giá 70.000đ bao gồm: thiết kế trang chuyên nghiệp, responsive trên mọi thiết bị, tối ưu SEO, tích hợp mạng xã hội, form liên hệ, tên miền miễn phí 1 năm và hỗ trợ kỹ thuật 30 ngày.'
    },
    {
      question: 'Tôi có được hoàn tiền nếu không hài lòng?',
      answer: 'Có, chúng tôi cam kết hoàn tiền 100% nếu bạn không hài lòng với sản phẩm trong vòng 7 ngày đầu tiên. Sự hài lòng của khách hàng là ưu tiên hàng đầu của chúng tôi.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-teal-100 rounded-full mb-6">
            <i className="ri-question-line text-lg text-teal-600"></i>
            <span className="text-sm font-semibold text-teal-700">Câu Hỏi Thường Gặp</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Giải Đáp Thắc Mắc<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-amber-600">
              Của Bạn
            </span>
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Những câu hỏi phổ biến từ khách hàng về dịch vụ của chúng tôi
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border-2 border-gray-100 overflow-hidden hover:border-gray-200 transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between gap-4 text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center gap-4 flex-1">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 transition-colors ${
                    openIndex === index 
                      ? 'bg-gradient-to-br from-teal-500 to-teal-600' 
                      : 'bg-gray-100'
                  }`}>
                    <i className={`ri-question-line text-xl ${
                      openIndex === index ? 'text-white' : 'text-gray-600'
                    }`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">
                    {faq.question}
                  </h3>
                </div>
                <i className={`ri-arrow-down-s-line text-2xl text-gray-400 transition-transform duration-300 flex-shrink-0 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}></i>
              </button>
              
              <div className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'max-h-96' : 'max-h-0'
              }`}>
                <div className="px-8 pb-6 pt-2">
                  <div className="pl-14">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">
            Vẫn còn thắc mắc? Liên hệ với chúng tôi
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="https://zalo.me/0902730008"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white font-semibold rounded-full hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-chat-3-line text-xl"></i>
              Chat Zalo
            </a>
            <a
              href="tel:0902730008"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-gray-900 font-semibold rounded-full border-2 border-gray-200 hover:border-gray-300 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              0902 730 008
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}